import {
  useNavigate,
  useLocation,
  useSearchParams as useRouterSearchParams,
  useParams,
} from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (url: string) => navigate(url),
    replace: (url: string) => navigate(url, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    prefetch: () => {},
    pathname: location.pathname,
  };
}

export function usePathname() {
  const { pathname } = useLocation();
  return pathname;
}

export function useSearchParams(): URLSearchParams {
  const [searchParams] = useRouterSearchParams();
  return searchParams;
}

export { useParams };

// Next-style server redirects become client-side navigation.
export function redirect(url: string): never {
  window.location.href = url;
  throw new Error('Redirect');
}
